module.exports = __webpack_public_path__ + "static/we_keep_standards-43a4c2d218db35018700f92cb537fb2f.jpg";